enum ExtractionOperation {
    COUNT,
    SUM,
    AVERAGE,
}

export const operationMap = [
    { value: ExtractionOperation.COUNT, label: 'Décompte' },
    { value: ExtractionOperation.SUM, label: 'Somme' },
    { value: ExtractionOperation.AVERAGE, label: 'Moyenne' },
]

export default ExtractionOperation;